import { failedIcon, notAllowedIcon, notFoundIcon } from "@/assets/default-icons";
import { t as translate } from "@/locales/i18n";
import type { useI18n } from "@/locales/i18n-provider";
import { RequestError } from "@/request/request-client/request-error";
import { isSessionExpiredError } from "@/request/request-client/session-expired";

/** 请求错误 → 缺省图 + 文案 + 是否可重试的统一映射。 */
type ErrorDisplay = {
  illustration: string;
  title: string;
  description: string;
  retryable: boolean;
};

type Translate = ReturnType<typeof useI18n>["t"];

export function resolveRequestErrorDisplay(error: unknown, t: Translate = translate): ErrorDisplay {
  if (isSessionExpiredError(error)) {
    return { illustration: notAllowedIcon, title: t("auth.sessionExpired.title"), description: t("auth.sessionExpired.detail"), retryable: false };
  }
  if (error instanceof RequestError) {
    if (error.status === 403) {
      return { illustration: notAllowedIcon, title: t("request.forbidden.title"), description: t("request.forbidden.description"), retryable: false };
    }
    if (error.status === 404) {
      return { illustration: notFoundIcon, title: t("request.notFound.title"), description: error.message, retryable: false };
    }
  }
  // ABP messages on RequestError are already localized by Accept-Language.
  // Native client errors are usually technical English, so keep those behind a localized fallback.
  const message = error instanceof RequestError && error.message ? error.message : t("request.failed.description");
  return { illustration: failedIcon, title: t("request.failed.title"), description: message, retryable: true };
}
